export function rowsPrepare(rows) {
    let datos = [];

    for (let i in rows) {
        datos.push(rows[i]);
    }

    return datos;
}